import React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { SystemIcon } from '@workday/canvas-kit-react/icon';
import { usePillModel } from './usePillModel';
import { plusIcon } from '@workday/canvas-system-icons-web';
import { space } from '@workday/canvas-kit-react/tokens';
export const PillIcon = createSubcomponent('span')({
    modelHook: usePillModel,
})(({ size, icon, ...elemProps }, Element) => {
    return (React.createElement(SystemIcon, Object.assign({ marginInlineStart: `-${space.xxxs}`, display: "flex", as: Element, size: 20, role: "img", "aria-label": "add", icon: icon || plusIcon }, elemProps)));
});
